import CookieHandler from "../utils/cookie-handler";
const {
	Image,
	NinetyNineData: { popupHash },
} = window;

export default class WelcomePopUp extends CookieHandler {
	constructor() {
		const popup = document.getElementById("welcome-pop-up");
		const expires = popup ? (1 / 1440) * popup.dataset.expirationTime : 2;

		super("hide-welcome-pop-up", expires, popupHash);

		if (!this.checkPopupHash() && popup) {
			this.popup = popup;
			this.popupContent = this.popup.querySelector(".popup-content");

			document.addEventListener("click", this.closePopUp.bind(this));

			document
				.getElementById("welcome-pop-up-close")
				.addEventListener("click", this.closePopUp.bind(this));

			this.openPopUp();
			window.addEventListener("resize", this.loadImages.bind(this));
		}
	}

	checkPopupHash() {
		return this.hasCookie() === popupHash;
	}

	openPopUp() {
		document.documentElement.classList.add("pop-up-visible");
		this.popup.classList.add("pop-up-open");
		this.loadImages();
	}

	closePopUp() {
		document.documentElement.classList.remove("pop-up-visible");
		this.popup.classList.remove("pop-up-open");

		this.setCookie();
	}

	adjustPopUp() {
		if (!document.documentElement.classList.contains("pop-up-visible")) {
			return;
		}

		this.popup.classList.remove("fixed-height");

		if (this.popupContent.scrollHeight > this.popupContent.offsetHeight) {
			this.popup.classList.add("fixed-height");
		}
	}

	loadImages() {
		const image = this.popup.querySelector("img");

		if (image.complete && image.naturalHeight !== 0) {
			this.adjustPopUp();
		} else {
			const img = new Image();

			img.addEventListener("load", () => {
				this.adjustPopUp();
			});

			img.src = image.src;
		}
	}
}
